// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"bSJgi9J"};